import { UiProfileProperty } from '../../../models/UiProfile';
import { DeviceEditablePropertyValue, SectionItemEditor } from '../buildEditor';

export function buildDateEditor(uiProperty: UiProfileProperty, value: DeviceEditablePropertyValue): SectionItemEditor {
    return { type: 'date', value };
}
